import { render, staticRenderFns } from "./DiscountPage.vue?vue&type=template&id=0568eb34&scoped=true&"
import script from "./DiscountPage.vue?vue&type=script&lang=js&"
export * from "./DiscountPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPage.vue?vue&type=style&index=0&id=0568eb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568eb34",
  null
  
)

export default component.exports